import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf
       } from '@angular/core';

import { ConfigService } from './config/config.service';
import { ErrorService } from './error/error.service';
import { FontStoreService } from './fontstore/fontstore.service';
import { ImageStoreService } from './imagestore/imagestore.service';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { LoggingService } from './logging/logging.service';
import { MatModule } from './material/mat.module';
import { PriceCalculationService } from './price/price-calculation.service';
import { PrnglService } from './prngl/prngl.service';
import { ProductService } from './product/product.service';
import { ProductUpgradeService
       } from './product-upgrade/product-upgrade.service';
import { ProductdesignerdService
       } from './productdesignerd/productdesignerd.service';
import { TraudlService } from './traudl/traudl.service';

@NgModule({
  imports: [ CommonModule, MatModule ],
  declarations: [],
  exports: [ ],
})
export class CoreModule
{
  public static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
          ConfigService,
          ErrorService,
          ImageStoreService,
          TraudlService,
          FontStoreService,
          LoggingService,
          PriceCalculationService,
          PrnglService,
          ProductdesignerdService,
          ProductService,
          ProductUpgradeService,
          {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
          },
      ],
    };
  }

  constructor (@Optional() @SkipSelf() parentModule: CoreModule)
  {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
